import {
    faAngleDoubleUp,
    faBars,
    faBolt,
    faCalendarAlt,
    faCalendarPlus,
    faCalendarTimes,
    faChartBar,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClipboardList,
    faClock,
    faCloudDownloadAlt,
    faCog,
    faCogs,
    faDesktop,
    faDownload,
    faEdit,
    faEnvelope,
    faEthernet,
    faExclamationCircle,
    faExclamationTriangle,
    faFile,
    faFileAudio,
    faFileDownload,
    faFileImage,
    faFileUpload,
    faFileVideo,
    faFlag,
    faFolderMinus,
    faGripLinesVertical,
    faHistory,
    faImage,
    faInbox,
    faInfo,
    faInfoCircle,
    faLanguage,
    faLockOpen,
    faMusic,
    faPencilAlt,
    faPhone,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusCircle,
    faPooStorm,
    faQuestion,
    faQuestionCircle,
    faRandom,
    faRedo,
    faSave,
    faSignOutAlt,
    faSlidersH,
    faSpinner,
    faStoreAlt,
    faTachometerAlt,
    faThumbtack,
    faTimes,
    faTrashAlt,
    faUser,
    faWifi,
    faWrench,
    faBan,
} from '@fortawesome/free-solid-svg-icons'

export default [
    faAngleDoubleUp,
    faBars,
    faBolt,
    faCalendarAlt,
    faCalendarPlus,
    faCalendarTimes,
    faChartBar,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClipboardList,
    faClock,
    faCloudDownloadAlt,
    faCog,
    faCogs,
    faDesktop,
    faDownload,
    faEdit,
    faEnvelope,
    faEthernet,
    faExclamationCircle,
    faExclamationTriangle,
    faFile,
    faFileDownload,
    faFileAudio,
    faFileImage,
    faFileUpload,
    faFileVideo,
    faFlag,
    faFolderMinus,
    faGripLinesVertical,
    faHistory,
    faImage,
    faInbox,
    faInfo,
    faInfoCircle,
    faLanguage,
    faLockOpen,
    faMusic,
    faPencilAlt,
    faPhone,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusCircle,
    faPooStorm,
    faQuestion,
    faQuestionCircle,
    faRandom,
    faRedo,
    faSave,
    faSignOutAlt,
    faSlidersH,
    faSpinner,
    faStoreAlt,
    faTachometerAlt,
    faThumbtack,
    faTimes,
    faTrashAlt,
    faUser,
    faWifi,
    faWrench,
    faWifi,
    faEthernet,
    faBan
]
